import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';


const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./login/login.module').then(m => m.DmpLoginModule),
    },
    {
        path: 'h',
        loadChildren: () => import('./admin/admin.module').then(m => m.DmpAdminModule)
    },
    {
        path: '**',
        redirectTo: 'h',
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
      enableTracing: false
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
